import CardLayout from '@/components/common/CardLayout';
import InputField from '@/components/common/InputField';
import Modal from '@/components/common/modals/Modal';
import ModalManager, { useModal } from '@/components/ModalManager';
import { useTrackModalShown } from '@/services/analytics/useTracking';
import { useMutation } from '@apollo/client';
import { Goal } from '@common/goals';
import { UpdateGoalDocument } from '@common/graphql/generated';
import { useState } from 'react';

export interface GoalRenameModalProps {
    goal: Goal;
}

export const showGoalRenameModal = (props: GoalRenameModalProps) =>
    ModalManager.show(GoalRenameModal, props);

const GoalRenameModal = ModalManager.create<GoalRenameModalProps>(
    ({ goal }) => {
        useTrackModalShown('Rename Goal');
        const modal = useModal();
        const [name, setName] = useState(goal.name);

        const [updateGoal, { loading }] = useMutation(UpdateGoalDocument);

        return (
            <Modal size="sm" isOpen={modal.visible} onClose={modal.remove}>
                <CardLayout
                    title={`What do you want to name this goal?`}
                    primaryButtonText="Save"
                    onPrimaryButton={() => {
                        updateGoal({
                            variables: {
                                id: goal.id,
                                name,
                            },
                        }).then(modal.remove);
                    }}
                    isPrimaryButtonLoading={loading}
                    onSecondaryButton={modal.remove}
                    onClickPrimaryEvent="Rename Goal Modal - Save Button Clicked"
                    onClickSecondaryEvent="Rename Goal Modal - Cancel Button Clicked"
                >
                    <InputField
                        label=""
                        name="name"
                        type="text"
                        onChange={setName}
                        value={name}
                        inputProps={{ variant: 'flushed' }}
                        tabIndex={1}
                    />
                </CardLayout>
            </Modal>
        );
    }
);

export default GoalRenameModal;
